var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
export default (function (user, recognition) {
    var userIds = recognition.userIds;
    var _a = user.teamIds, userTeams = _a === void 0 ? [] : _a;
    // Cover case where userIds === null
    var userIdList = userIds || [];
    var receiversTeams = userIdList
        .map(function (receiver) {
        var _a;
        if ((_a = receiver.teams) === null || _a === void 0 ? void 0 : _a.results) {
            return receiver.teams.results;
        }
        return receiver.teams;
    })
        .filter(function (teams) { return teams; }) // filters out null or undefined teams
        .reduce(function (carry, teams) { return __spreadArrays(carry, teams.map(function (_a) {
        var uuid = _a.uuid;
        return uuid;
    })); }, []);
    var ids = new Set(__spreadArrays(receiversTeams, userTeams));
    return ids.size > 0;
});
